import {Body1, Box, styled, Tooltip} from '../../../ui-library';
import {tooltipClasses} from '@mui/material';
import React from 'react';

export const ContainerBox = styled(Box)`
    display: flex;
    flex-direction: column;
    padding: 16px;
    border-radius: 10px;
    background:  ${({ theme }) => theme.palette.grey[700]};
    margin-top: 27px;
    width: 322px;
    height: 227px;
    box-sizing: border-box;
`;

export const SubTitle = styled(Body1)`
    color: #FFFFFF;
    font-size: 12px;
`;

export const ClassName = styled(Body1)`
    color: #FFFFFF;
    font-size: 20px;
    font-weight: 600;
`;

export const ReferenceTitle = styled(Body1)`
    color: #FFFFFF;
    font-size: 16px;
    font-weight: 600;
    margin-top: 27px;
`;

export const CustomTooltip = styled(({ className, ...props }: any) => (
    <Tooltip {...props} classes={{ popper: className }} />
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: 'rgba(17, 24, 39, 0.9)',
    },
}));


export const ImagesContainer = styled(Box)`
    display: flex;
    flex-direction: row;
    gap:10px;
    margin-top: 10px;
    width: 290px;
`;
